import { all, takeEvery, put, call } from 'redux-saga/effects'
import toursApi from 'services/tours'
import { actions } from './actions'

export function* loadProfileTours({ payload }) {
  try {
    const response = yield call(toursApi.loadTours, payload)
    yield put({
      type: actions.LOAD_PROFILE_TOURS_RESULT,
      payload: response,
    })
  } catch (error) {
    yield put({
      type: actions.LOAD_PROFILE_TOURS_RESULT,
      error,
    })
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD_PROFILE_TOURS_REQUEST, loadProfileTours)])
}
